/**
 * Bridges importReview and dashboard: after a confirmed import the Server
 * recomputes analysis in the background, so the dashboard needs to know an
 * import just landed to pick its `analyzing` state over `ready`.
 *
 * Cleared as soon as a score computed after the import comes back.
 */
const KEY = 'fintech.import.pendingSince'

export function markImportPending(at = new Date().toISOString()): void {
  try {
    sessionStorage.setItem(KEY, at)
  } catch {
    /* private mode */
  }
}

export function pendingImportSince(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function clearImportPending(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* private mode */
  }
}
